export default __webpack_public_path__ + "static/media/illustration1.3bc478cd.svg";